export type Cashier = {
  status: CashierStatus;
  openTime?: number | null;
};

export enum CashierStatus {
  Open = 'open',
  Closed = 'closed',
}
